module.exports = __webpack_public_path__ + "img/01 02_big bowl.e005ae63.png";